var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) { ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } } return n; }, _extends.apply(null, arguments); }

function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) { o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } } return i; }

function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) { if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } } return t; }

import * as React from "react";

function SvgPaymentsActive(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.62921 7.74061C8.76465 7.65031 8.93197 7.5696 9.125 7.50713L9.12501 8.99287C8.93197 8.9304 8.76465 8.84969 8.62921 8.75939C8.31061 8.547 8.25 8.34966 8.25 8.25C8.25 8.15034 8.31061 7.953 8.62921 7.74061Z",
    fill: "#525252"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M10.875 12.4929L10.875 11.0071C11.068 11.0696 11.2354 11.1503 11.3708 11.2406C11.6894 11.453 11.75 11.6503 11.75 11.75C11.75 11.8497 11.6894 12.047 11.3708 12.2594C11.2354 12.3497 11.0681 12.4304 10.875 12.4929Z",
    fill: "#525252"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M10 17C13.866 17 17 13.866 17 10C17 6.13401 13.866 3 10 3C6.13401 3 3 6.13401 3 10C3 13.866 6.13401 17 10 17ZM10.875 5.625C10.875 5.14175 10.4832 4.75 10 4.75C9.51675 4.75 9.125 5.14175 9.125 5.625V5.70549C8.5811 5.80764 8.07804 6.00481 7.65848 6.28452C7.02701 6.7055 6.5 7.38317 6.5 8.25C6.5 9.11683 7.02701 9.7945 7.65848 10.2155C8.07805 10.4952 8.58111 10.6924 9.12501 10.7945L9.12502 12.4931C8.78289 12.382 8.52927 12.2154 8.38708 12.0515C8.07037 11.6865 7.51774 11.6474 7.15274 11.9641C6.78774 12.2808 6.7486 12.8335 7.06531 13.1985C7.55749 13.7657 8.30211 14.1395 9.125 14.2942L9.125 14.375C9.12499 14.8582 9.51673 15.25 9.99998 15.25C10.4832 15.25 10.875 14.8583 10.875 14.375L10.875 14.2945C11.4189 14.1924 11.922 13.9952 12.3415 13.7155C12.973 13.2945 13.5 12.6168 13.5 11.75C13.5 10.8832 12.973 10.2055 12.3415 9.78452C11.922 9.50481 11.4189 9.30764 10.875 9.20549L10.875 7.50691C11.2171 7.61799 11.4707 7.78458 11.6129 7.94846C11.9296 8.31345 12.4823 8.3526 12.8473 8.03589C13.2123 7.71918 13.2514 7.16654 12.9347 6.80154C12.4425 6.23432 11.6979 5.86051 10.875 5.70581V5.625Z",
    fill: "#525252"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPaymentsActive);
export default __webpack_public_path__ + "static/media/payments-active.92fc9a269f169fccba22ef18a216cf91.svg";
export { ForwardRef as ReactComponent };